import styled from 'styled-components'
import { InputWrapper } from './Input.styles'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const AmountsContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 8px;

  @media (max-width: 1120px) {
    grid-template-columns: auto auto;
  }
`

export const Amount = styled.button<{ selected: boolean }>`
  padding: 12px 20px;
  border: 1px solid var(--brand-secondary);
  border-radius: 64px;
  cursor: pointer;
  background: white;
  color: var(--brand-secondary);
  font-weight: var(--font-medium);
  font-size: 14px;
  font-family: inherit;

  &:hover {
    background: var(--brand-secondary);
    border-color: var(--brand-secondary);
    color: white;
  }

  ${({ selected }) =>
    selected &&
    `
    background: var(--brand-secondary);
    border-color: var(--brand-secondary);
    color: white;
  `}
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 15px;

  ${InputWrapper} {
    width: 150px;
  }
`

export const CustomAmountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
